import { createTheme } from '@mui/material/styles';
import { baseTheme } from './base';
import { getComponents } from './components';
import { lightPalette } from './palette/lightPalette';
import { lightShadows } from './shadows';
import type { Theme } from '@mui/material/styles';

/**
 * Light theme - sibling to dark theme with same structure
 */
export const createLightTheme = (): Theme => {
  const theme = createTheme({
    ...baseTheme,
    palette: lightPalette,
    shadows: lightShadows,
  });

  return createTheme(theme, {
    components: getComponents(theme),
  });
};
